import { createBrowserRouter } from 'react-router'

import { PageError } from '@enechain/ecloud-designsystem'
import { ErrorLayout } from '@enechain/eposition-ui'

import MainLayout from '~/components/layouts/MainLayout'
import { ContractListPage } from '~/pages/ContractList'
import { MarginReportPage } from '~/pages/MarginReport'
import { SimulationPage } from '~/pages/Simulation'
import {
  PATH_CONTRACT_LIST,
  PATH_HOME,
  PATH_MARGIN_REPORT,
  PATH_SIMULATION,
} from '~/routes/routePaths'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const router = () =>
  createBrowserRouter([
    {
      element: <MainLayout />,
      errorElement: <ErrorLayout />,
      children: [
        {
          path: PATH_HOME.path,
          element: <SimulationPage />,
        },
        {
          path: PATH_SIMULATION.path,
          element: <SimulationPage />,
        },
        {
          path: PATH_CONTRACT_LIST.path,
          element: <ContractListPage />,
        },
        {
          path: PATH_MARGIN_REPORT.path,
          element: <MarginReportPage />,
        },
        {
          path: '*',
          element: <PageError kind="404" />,
        },
      ],
    },
  ])
